// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-and-instruction-step6 {
  display: flex;
  align-items: center;
  gap: 15px; /* Space between step circle and text */
  padding-left: 20px;
}

.info-message-step6 {
  background-color: #d4edda;
  color: #155724;
  padding: 12px 15px;
  margin: 10px 0 20px 0;
  border-radius: 5px;
  font-size: 1rem;
  text-align: center;
  border-left: 4px solid #28a745;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: fadeInFadeOut 3s ease-in-out;
}

@keyframes fadeInFadeOut {
  0% { opacity: 0; transform: translateY(-10px); }
  15% { opacity: 1; transform: translateY(0); }
  85% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-10px); }
}

/* Step 6 Container (Optional: for specific spacing/styling) */
.step-six-container {
  /* Add any specific styles for the step 6 container */
  margin-bottom: 30px; /* Example spacing */
}

.step-six-container .step-description {
  font-size: 14px; /* Slightly more readable size */
  color: #110351; /* Softer color */
  margin-top: 5px; /* Space above */
  margin-bottom: 15px; /* Space below */
  padding: 10px; /* Inner padding */
  background-color: #f9f9f9; /* Light background */
  border-left: 3px solid #007bff; /* Left highlight bar */
  line-height: 1.5; /* Line height */
  max-width: 90%; /* Limit width (optional) */
  text-align: left; /* Align text left */
}

/* Area containing the button and selected tags */
.non-feature-selection-area {
  margin-top: 20px;
  padding: 20px;
  background-color: #f8f9fa; /* Light background */
  border-radius: 8px;
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align items to the start */
}

/* Style for the 'Specify Non-Feature Columns' button */
.specify-non-feature-button {
  background-color: #17a2b8; /* Teal color */
  color: white;
  padding: 12px 25px;
  font-size: 1.1rem;
  border-radius: 6px;
  transition: background-color 0.3s ease;
  display: inline-flex; /* Align badge correctly */
  align-items: center;
  margin-bottom: 15px; /* Space below the button */
}

.specify-non-feature-button:hover {
  background-color: #138496; /* Darker teal */
}

.specify-non-feature-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* Badge inside the button showing the count */
.selected-count-badge {
  background-color: rgba(255, 255, 255, 0.3); /* Semi-transparent white */
  color: white;
  padding: 3px 8px;
  border-radius: 10px; /* Pill shape */
  font-size: 0.85rem;
  margin-left: 10px;
  font-weight: bold;
}

/* Container for the selected non-feature tags */
.selected-non-features-container {
  margin-top: 10px;
  margin-bottom: 20px; /* Add space below tags before confirm button */
  width: 100%;
  display: flex; /* Use flexbox for alignment */
  flex-wrap: wrap; /* Allow tags to wrap to the next line */
  align-items: center; /* Vertically align label and tags */
  gap: 8px; /* Spacing between label and tags, and between tags */
}

/* Label before the tags */
.selected-label {
  font-weight: bold;
  color: #555;
  margin-left: 10px; /* Space between label and first tag */
}

/* Individual tag styling (adjust padding for the button) */
.non-feature-tag {
  display: inline-flex; /* Use flex to align text and button */
  align-items: center; /* Vertically center items */
  background-color: #e9ecef;
  color: #495057;
  padding: 6px 8px 6px 12px; /* Adjust right padding */
  border-radius: 15px;
  font-size: 0.9rem;
  white-space: nowrap;
  border: 1px solid #ced4da;
  /* gap: 5px; /* Optional: space between text and button via flex gap */
}

/* Remove button inside the tag */
.non-feature-tag-remove {
  display: inline-flex; /* Ensure it behaves like an inline element */
  align-items: center;
  justify-content: center;
  width: 16px; /* Fixed size */
  height: 16px; /* Fixed size */
  margin-left: 8px; /* Space between text and button */
  padding: 0;
  border: none;
  background-color: #adb5bd; /* Grey background */
  color: white; /* White 'x' */
  border-radius: 50%; /* Make it circular */
  cursor: pointer;
  font-weight: bold;
  font-size: 0.8rem; /* Adjust size of 'x' */
  line-height: 1; /* Ensure 'x' is centered vertically */
  transition: background-color 0.2s ease;
}

.non-feature-tag-remove:hover {
  background-color: #dc3545; /* Red background on hover */
}

.non-feature-tag-remove:focus {
  outline: none; /* Remove default focus outline */
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.5); /* Add custom focus style */
}

/* Optional: Info text styling */
.info-text {
  color: #6c757d;
  font-size: 0.9rem;
  margin-top: 5px;
}

/* Style for the new 'Confirm Non-Feature Selection' button */
.confirm-non-feature-button {
  background-color: #28a745; /* Green color for confirmation */
  color: white;
  padding: 12px 25px;
  font-size: 1.1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 15px; /* Add space above the button */
  /* Align with the specify button or center it if needed */
}

.confirm-non-feature-button:hover {
  background-color: #218838; /* Darker green */
}

.confirm-non-feature-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/css/step6-selectFeature.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,uCAAuC;EAClD,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA,8DAA8D;AAC9D;EACE,qDAAqD;EACrD,mBAAmB,EAAE,oBAAoB;AAC3C;;AAEA;EACE,eAAe,EAAE,gCAAgC;EACjD,cAAc,EAAE,iBAAiB;EACjC,eAAe,EAAE,gBAAgB;EACjC,mBAAmB,EAAE,gBAAgB;EACrC,aAAa,EAAE,kBAAkB;EACjC,yBAAyB,EAAE,qBAAqB;EAChD,8BAA8B,EAAE,uBAAuB;EACvD,gBAAgB,EAAE,gBAAgB;EAClC,cAAc,EAAE,2BAA2B;EAC3C,gBAAgB,EAAE,oBAAoB;AACxC;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,6BAA6B;AACxD;;AAEA,uDAAuD;AACvD;EACE,yBAAyB,EAAE,eAAe;EAC1C,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,oBAAoB,EAAE,0BAA0B;EAChD,mBAAmB;EACnB,mBAAmB,EAAE,2BAA2B;AAClD;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,0CAA0C,EAAE,2BAA2B;EACvE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB,EAAE,eAAe;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,mBAAmB,EAAE,+CAA+C;EACpE,WAAW;EACX,aAAa,EAAE,8BAA8B;EAC7C,eAAe,EAAE,wCAAwC;EACzD,mBAAmB,EAAE,oCAAoC;EACzD,QAAQ,EAAE,qDAAqD;AACjE;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB,EAAE,sCAAsC;AAC3D;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB,EAAE,sCAAsC;EAC5D,mBAAmB,EAAE,4BAA4B;EACjD,yBAAyB;EACzB,cAAc;EACd,yBAAyB,EAAE,yBAAyB;EACpD,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,sEAAsE;AACxE;;AAEA,iCAAiC;AACjC;EACE,oBAAoB,EAAE,6CAA6C;EACnE,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,eAAe;EAC5B,YAAY,EAAE,eAAe;EAC7B,gBAAgB,EAAE,kCAAkC;EACpD,UAAU;EACV,YAAY;EACZ,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY,EAAE,cAAc;EAC5B,kBAAkB,EAAE,qBAAqB;EACzC,eAAe;EACf,iBAAiB;EACjB,iBAAiB,EAAE,uBAAuB;EAC1C,cAAc,EAAE,sCAAsC;EACtD,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA;EACE,aAAa,EAAE,iCAAiC;EAChD,4CAA4C,EAAE,2BAA2B;AAC3E;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB,EAAE,+BAA+B;EACjD,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".step-and-instruction-step6 {\n  display: flex;\n  align-items: center;\n  gap: 15px; /* Space between step circle and text */\n  padding-left: 20px;\n}\n\n.info-message-step6 {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 12px 15px;\n  margin: 10px 0 20px 0;\n  border-radius: 5px;\n  font-size: 1rem;\n  text-align: center;\n  border-left: 4px solid #28a745;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  animation: fadeInFadeOut 3s ease-in-out;\n}\n\n@keyframes fadeInFadeOut {\n  0% { opacity: 0; transform: translateY(-10px); }\n  15% { opacity: 1; transform: translateY(0); }\n  85% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-10px); }\n}\n\n/* Step 6 Container (Optional: for specific spacing/styling) */\n.step-six-container {\n  /* Add any specific styles for the step 6 container */\n  margin-bottom: 30px; /* Example spacing */\n}\n\n.step-six-container .step-description {\n  font-size: 14px; /* Slightly more readable size */\n  color: #110351; /* Softer color */\n  margin-top: 5px; /* Space above */\n  margin-bottom: 15px; /* Space below */\n  padding: 10px; /* Inner padding */\n  background-color: #f9f9f9; /* Light background */\n  border-left: 3px solid #007bff; /* Left highlight bar */\n  line-height: 1.5; /* Line height */\n  max-width: 90%; /* Limit width (optional) */\n  text-align: left; /* Align text left */\n}\n\n/* Area containing the button and selected tags */\n.non-feature-selection-area {\n  margin-top: 20px;\n  padding: 20px;\n  background-color: #f8f9fa; /* Light background */\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* Align items to the start */\n}\n\n/* Style for the 'Specify Non-Feature Columns' button */\n.specify-non-feature-button {\n  background-color: #17a2b8; /* Teal color */\n  color: white;\n  padding: 12px 25px;\n  font-size: 1.1rem;\n  border-radius: 6px;\n  transition: background-color 0.3s ease;\n  display: inline-flex; /* Align badge correctly */\n  align-items: center;\n  margin-bottom: 15px; /* Space below the button */\n}\n\n.specify-non-feature-button:hover {\n  background-color: #138496; /* Darker teal */\n}\n\n.specify-non-feature-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n/* Badge inside the button showing the count */\n.selected-count-badge {\n  background-color: rgba(255, 255, 255, 0.3); /* Semi-transparent white */\n  color: white;\n  padding: 3px 8px;\n  border-radius: 10px; /* Pill shape */\n  font-size: 0.85rem;\n  margin-left: 10px;\n  font-weight: bold;\n}\n\n/* Container for the selected non-feature tags */\n.selected-non-features-container {\n  margin-top: 10px;\n  margin-bottom: 20px; /* Add space below tags before confirm button */\n  width: 100%;\n  display: flex; /* Use flexbox for alignment */\n  flex-wrap: wrap; /* Allow tags to wrap to the next line */\n  align-items: center; /* Vertically align label and tags */\n  gap: 8px; /* Spacing between label and tags, and between tags */\n}\n\n/* Label before the tags */\n.selected-label {\n  font-weight: bold;\n  color: #555;\n  margin-left: 10px; /* Space between label and first tag */\n}\n\n/* Individual tag styling (adjust padding for the button) */\n.non-feature-tag {\n  display: inline-flex; /* Use flex to align text and button */\n  align-items: center; /* Vertically center items */\n  background-color: #e9ecef;\n  color: #495057;\n  padding: 6px 8px 6px 12px; /* Adjust right padding */\n  border-radius: 15px;\n  font-size: 0.9rem;\n  white-space: nowrap;\n  border: 1px solid #ced4da;\n  /* gap: 5px; /* Optional: space between text and button via flex gap */\n}\n\n/* Remove button inside the tag */\n.non-feature-tag-remove {\n  display: inline-flex; /* Ensure it behaves like an inline element */\n  align-items: center;\n  justify-content: center;\n  width: 16px; /* Fixed size */\n  height: 16px; /* Fixed size */\n  margin-left: 8px; /* Space between text and button */\n  padding: 0;\n  border: none;\n  background-color: #adb5bd; /* Grey background */\n  color: white; /* White 'x' */\n  border-radius: 50%; /* Make it circular */\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 0.8rem; /* Adjust size of 'x' */\n  line-height: 1; /* Ensure 'x' is centered vertically */\n  transition: background-color 0.2s ease;\n}\n\n.non-feature-tag-remove:hover {\n  background-color: #dc3545; /* Red background on hover */\n}\n\n.non-feature-tag-remove:focus {\n  outline: none; /* Remove default focus outline */\n  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.5); /* Add custom focus style */\n}\n\n/* Optional: Info text styling */\n.info-text {\n  color: #6c757d;\n  font-size: 0.9rem;\n  margin-top: 5px;\n}\n\n/* Style for the new 'Confirm Non-Feature Selection' button */\n.confirm-non-feature-button {\n  background-color: #28a745; /* Green color for confirmation */\n  color: white;\n  padding: 12px 25px;\n  font-size: 1.1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-top: 15px; /* Add space above the button */\n  /* Align with the specify button or center it if needed */\n}\n\n.confirm-non-feature-button:hover {\n  background-color: #218838; /* Darker green */\n}\n\n.confirm-non-feature-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
